export default {
  about: {
    hero: {
      eyebrow: 'À propos',
      title: 'Personnel. Professionnel. Précis.',
      lead: '{{name}}, c’est une vidéosurveillance planifiée individuellement et un accompagnement personnel de bout en bout.',
    },
    story: {
      quote: '« Plutôt que de vendre des formules toutes faites, chaque bien est étudié selon ses besoins réels – des zones d’image souhaitées aux points de montage, en passant par l’enregistrement et la configuration de l’app. »',
      p1: '{{name}} est dirigée par {{owner}}, votre contact personnel de la première consultation au suivi continu. Il travaille dans la sécurité depuis plus de 20 ans et a réalisé des centaines de projets pour particuliers et professionnels.',
      p2: 'La longue expérience couvre la planification et l’installation de systèmes de caméras dans maisons, immeubles, commerces, bureaux, cabinets, restaurants, entrepôts, ateliers et zones de production. Chaque projet est étudié individuellement.',
      p3: 'Selon les exigences du projet, {{name}} utilise notamment des systèmes éprouvés de Hikvision et Safire. Des solutions d’autres fabricants peuvent aussi être planifiées.',
      p4: '{{name}} ne se considère pas comme un simple vendeur, mais comme un partenaire à long terme. Après l’installation, le contact personnel reste.',
    },
    owner: {
      subtitle: 'Technologie de sécurité de Hainburg',
      photoPlaceholder: 'Photo du dirigeant à venir',
      role: 'Dirigeant et contact',
    },
    milestonesTitle: 'Une expérience qui se fait sentir',
    milestones: {
      '0': { year: 'Plus de 20 ans', desc: 'Expérience en planification et installation de systèmes de caméras pour particuliers et professionnels dans la région Rhin-Main.' },
      '1': { year: 'Des centaines de projets', desc: 'Des maisons aux commerces en passant par de grandes installations : chaque projet planifié individuellement.' },
      '2': { year: 'Indépendant des fabricants', desc: 'Nous choisissons la technologie adaptée à vos besoins, selon le projet, chez divers fabricants renommés.' },
    },
    valuesTitle: 'Ce qui fait {{name}}',
    values: {
      '0': { title: 'Planification individuelle', desc: 'Pas de formules toutes faites. Chaque bien est étudié selon ses besoins réels.' },
      '1': { title: 'Mise en œuvre professionnelle', desc: 'Installation propre, orientation correcte et câblage professionnel.' },
      '2': { title: 'Connexion numérique', desc: 'App, accès à distance et notifications, configurés et expliqués.' },
      '3': { title: 'Accompagnement personnel', desc: 'Un seul contact. De confiance. Fiable. Même après l’installation.' },
    },
    cta: {
      title: 'Faites notre connaissance',
      lead: 'Un premier entretien sans engagement montre vite si nous sommes faits pour travailler ensemble. Au plaisir de découvrir votre projet.',
      primary: 'Prendre rendez-vous',
      secondary: 'Questions fréquentes',
    },
  },
};